import Timestamp from "components/Timestamp";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ScansListItem } from "../../../types";

const ScansTableLastScanCell = ({
  item: scan,
  ...cellProps
}: TableSimpleCellProps<ScansListItem>) => (
  <TableSimpleCell {...cellProps}>
    {scan.latestRun ? <Timestamp timestamp={scan.latestRun.stateChangedAt} /> : <TableCellEmpty />}
  </TableSimpleCell>
);

export default ScansTableLastScanCell;
